import { gql, useQuery } from "@apollo/client";

export type EventDetails = {
  homeTeam: EventDetailsTeam;
  awayTeam: EventDetailsTeam;
};

export type EventDetailsTeam = {
  record: string;
  summary: TeamSummary[];
};

export type TeamSummary = {
  name: string;
  value?: string | null;
  color?: string | null;
};

export const useEventDetails = (eventId?: string) =>
  useQuery<{ eventDetails: EventDetails }>(
    gql`
      fragment EventDetailsTeamParts on EventDetailsTeam {
        record
        summary {
          name
          value
          color
        }
      }
      query eventDetailsQuery($eventId: String!) {
        eventDetails(id: $eventId) {
          homeTeam {
            ...EventDetailsTeamParts
          }
          awayTeam {
            ...EventDetailsTeamParts
          }
        }
      }
    `,
    {
      variables: { eventId: eventId || "" },
      skip: !eventId,
    }
  );
